export function switch_(ctx) {
    return {
        // No per-state overrides: firmware's pretty/pretty_color/sw_knob styles
        // (lv_theme_hasp.c) only ever set LV_STATE_DEFAULT for switch's 3 parts.
        styles: {
            main:      { ...ctx.pretty, radius: 999, border_width: 0 },
            // indicator = pretty_color
            indicator: { bg_color: ctx.indic, radius: 999, border_color: 'black', border_width: 0 },
            // knob = sw_knob
            knob:      { bg_color: '#808080', radius: 999, border_color: 'black', border_width: 0, padding: 0 },
        },
    };
}
